export default {
  unlockCodeMustBeUniq: 'Unlock code must be unique',
  nameMustBeUniq: 'Name must be unique',
  questionMustBeUniq: 'Question must be unique',
  unlockDiffrentFinalCode: 'Unlock code must be different from final code',
};
